var map = {
	"./ArrowButtonNex.png": "0457",
	"./ArrowButtonPre.png": "00d8",
	"./BtnClose.png": "cdc4",
	"./BtnSetting.png": "5f94",
	"./Burst.png": "2fd6",
	"./EggCracked.png": "c84b",
	"./Energy.png": "2904",
	"./Hamochi.png": "e49c",
	"./HamochiResult1.png": "00ba",
	"./HamochiResult2.png": "cee6",
	"./HamochiX.png": "b2ab",
	"./Homework fail 1.png": "f0e1",
	"./Homework success.png": "278c",
	"./LandIsland.png": "8393",
	"./LandMarket.png": "7776",
	"./LandPlayground.png": "dce6",
	"./LandTown.png": "b9c1",
	"./Locked.png": "db22",
	"./LuckyEgg.png": "1b03",
	"./LuckyEggChika.png": "30a5",
	"./MochiCoin.png": "420a",
	"./NavPin.png": "7b54",
	"./ShopPandamochi.png": "5f4a",
	"./TextureBricks.png": "a648",
	"./TextureGrass.png": "debc",
	"./TextureSand.png": "e598",
	"./TextureWood.png": "7803",
	"./hamochConfirm.png": "9022",
	"./hamochiLike.png": "d244",
	"./hamochi_sad.png": "7e66",
	"./loadingError.png": "f017",
	"./loadingError2.png": "901c",
	"./rainbow.png": "e6ee",
	"./tick.png": "a530"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a83";